import React, { useEffect, useRef, useState } from 'react';

export default function Menu({ onSelect }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, []);

  return (
    <div className="menu-container" ref={ref}>
      <button className="hamburger" aria-label="Open menu" onClick={() => setOpen(o => !o)}>☰</button>
      {open && (
        <div className="menu-dropdown" role="menu">
          <button className="menu-item" onClick={() => { setOpen(false); onSelect && onSelect('main'); }}>WerWarDran</button>
          <button className="menu-item" onClick={() => { setOpen(false); onSelect && onSelect('orderlists'); }}>Einkaufen</button>
        </div>
      )}
    </div>
  );
}
